import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import withDynamicUrlValidation from "UIComponents/DynamicUrlValidator";
const validateFunction = ({ path, pathName }) => {
  if (pathName === ":insightType") {
    if (_.isNaN(path)) {
      return _.includes(
        ["skills", "globalContexts", "lpas", "objectives", "krc"],
        path
      );
    }

    // custom datasets have number as insightType
    else return true;
  }
};
export default store => ({
  path: ":insightType",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "planning-insights" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return withDynamicUrlValidation({
          component,
          urlValidationType: "customValidation",
          customUrlValidationFunction: validateFunction,
        });
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
